import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-lagerstamm-list-view',
  imports: [],
  templateUrl: './lagerstamm.list-view.html',
  styleUrls: ['./lagerstamm.list-view.css'],
})
export class LagerstammListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
